import renderAutoSuggestWithOptions from 'app/employer/components/autoSuggest/AutoSuggestHOC';
import { SmsPhoneBankAutoCompleteInput$, SmsPhoneBankAutoCompleteObservable$ } from 'app/employer/redux/autosuggest/autoCompleteService';

const SmsPhoneBankAutoSuggest = renderAutoSuggestWithOptions(
   SmsPhoneBankAutoCompleteObservable$,
   SmsPhoneBankAutoCompleteInput$,
);

SmsPhoneBankAutoSuggest.defaultProps = {
   selected: {
      id: null,
      name: '',
   },
   forceSelection: false,
   placeholder: 'Search RefId...',
};

export default SmsPhoneBankAutoSuggest;
